import React, {useState, useEffect} from 'react'
import axiosInstance from '../../http/axios';

import Toast from '../../toast';
import Header from '../header/Header';

import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"

import ArrowBackRounded from '@mui/icons-material/ArrowBackRounded';
import { IconButton } from '@mui/material';
import DropdownMenu from '../dropdown_menu/DropdownMenu';
import {Pagination} from '@mui/material';

import SearchOutlined from '@mui/icons-material/SearchOutlined';

import "./User.css";
import NavLink from '../nav_link/NavLink';

const Devices = () => {

     const naviagte = (a)=> {
          if(typeof a == 'string'){
               window.location.href = a;
          }
          else if(typeof a == 'number'){
               window.history.go(a);
          }
     };

     const [data, setData] = useState([]);
     const [maxLength, setMaxDataLength] = useState(0);
     const [errorMessage, setErrorMessage] = useState(null);
     const [userAccountStatus, setUserAccountStatus] = useState("active");
     const [searchQuery, setSearchQuery] = useState(null);
     const tableHead = ["Device Name", "Device ID", "Contact Number", "Retailer ID", "Membership", "Date"];

     const onPageChange = async (e, pageIndex, status) => {
          try {
               const params = new URLSearchParams();
               params.append("skip", 20 * (pageIndex-1));
               params.append("limit", 20);
               params.append("filterByNew", true);

               if(searchQuery){
                    params.append("searchQuery", searchQuery);
               }
               if(status){
                    params.append("accountStatus", status);
               }
               else params.append("accountStatus", userAccountStatus);
               const res = await axiosInstance.get('admin/devices', {
                    params: params
               });
               setErrorMessage(null);
               setData(res.data.data);
               setMaxDataLength(res.data.maxLength);
          } 
          catch (error) {
               setErrorMessage("Failed");
          }
     }

     useEffect(async ()=>{
          onPageChange(null, 1);
     }, []);

     return (
          <>
               <div className="d-flex justify-content-between">
                    <div style={{height: '80px'}} className='d-flex align-items-center'>
                         {/* <IconButton onClick={()=>naviagte(-1)}><ArrowBackRounded/></IconButton> */}
                         <h5  style={{marginLeft: '10px', height: '100%', marginTop: '5px'}} className='d-flex align-items-center'>Devices</h5>
                    </div>
                    <div className='d-flex align-items-center'>
                         <div className='d-flex align-items-center' style={{border: '1px solid #A29694', marginRight: "20px", padding: '7px 20px', borderRadius: "5px"}}>
                              <input type="text" style={{background: "#F2EDF3", border: 'none', marginRight: "20px", }} placeholder='Contact number...' onChange={(e)=>setSearchQuery(e.target.value.trim())}/>
                              <SearchOutlined htmlColor='#A29694' onClick={()=>{
                                   onPageChange(null, 1, userAccountStatus);
                              }} />
                         </div>
                         {/* <DropdownMenu items={["Active users", "Blocked users"]} onChange={(value, i)=> {
                                   const status = i == 0 ? "active" : "blocked";
                                   setUserAccountStatus(status);
                                   onPageChange(null, 1, status);
                              }}/> */}
                    </div>
               </div>
               <div className="__table_root">
                    <table cellspacing="0" cellpadding="0" className="table">
                    <tr>
                         { tableHead.map((value, i)=> <th>{value}</th>) }
                    </tr>
                    { errorMessage ? null : ( data.length != 0 ? data.map((value, i)=> <Item data={value} position={i}/>) : null) }
                    </table>
                    { data.length != 0 ? null : <ErrorMessage message='Empty'/> }
                    { errorMessage&&data.length != 0 ? <ErrorMessage message={errorMessage}/> : null }
                    <div className='d-flex justify-content-between'>
                    <div></div>
                         <Pagination onChange={onPageChange} count={maxLength != 0 ? ~~((maxLength/20)+1) : 0} shape="rounded" />
                    </div>
               </div>
          </>
     );
}

const Item = (props) => {
     const [data, setData] = useState(props.data);
     const { _id, name, deviceId, contactNumber, retailerId, membership, date,} = data;

     const onRemoveRetailer = async ()=> {
          try {
               const rBody = new FormData();
               rBody.append("id", _id);
               const res = await axiosInstance.patch("admin/device-remove-retailer", rBody, 
                    {
                         headers: { "Content-Type": "multipart/form-data" }
                    }
               );
               setData({
                    ...data,
                    retailerId: null,
               });
          } catch (error) {
               console.log(error);
               Toast.error('Failed');
          }
     }

     const onMembershipAction = async (action) => {
          try {
               var membershipExpireAt;
               if(action == "ACTIVE_30D"){
                    membershipExpireAt = 1000*60*60*24*30;
               }
               else if(action == "ACTIVE_1Y"){
                    membershipExpireAt = 1000*60*60*24*365;
               }
               else if(action == "ACTIVE_LIFETIME"){
                    membershipExpireAt = 1000*60*60*24*9999999;
               }
               else {
                    membershipExpireAt = -99999;
               }
               const rBody = new FormData();
               rBody.append("id", _id);
               rBody.append("date", membershipExpireAt);
               const res = await axiosInstance.patch("admin/device-set-membership", rBody, 
                    {
                         headers: { "Content-Type": "multipart/form-data" }
                    }
               );
               setData({
                    ...data,
                    membership: membershipExpireAt < 0 ? "NONE" : new Date(Date.now() + membershipExpireAt).toLocaleDateString(),
               });
          } catch (error) {
               console.log(error);
               Toast.error('Failed');
          }
     }

     return(
          <tr>
               <td>{name}</td>
               <td>{deviceId}</td>
               <td>{contactNumber}</td>
               <td>{retailerId||"--"}{retailerId ? <button onClick={onRemoveRetailer} style={{background: "red", marginLeft: "10px", border: "none", color: "white", padding: "5px 5px", borderRadius: "5px"}} >Remove</button>:null}</td>    
               <td>
                    {membership == "NONE" ? "NONE" : new Date(membership).toLocaleDateString()}
                    {membership == "NONE" ? 
                    <>
                         <button onClick={()=> onMembershipAction("ACTIVE_30D")} style={{background: "green", marginLeft: "10px", border: "none", color: "white", padding: "5px 5px", borderRadius: "5px"}} >Active for 30D</button>
                         <button onClick={()=> onMembershipAction("ACTIVE_1Y")} style={{background: "green", marginLeft: "10px", border: "none", color: "white", padding: "5px 5px", borderRadius: "5px"}} >Active for 1 Year</button>
                         <button onClick={()=> onMembershipAction("ACTIVE_LIFETIME")} style={{background: "green", marginLeft: "10px", border: "none", color: "white", padding: "5px 5px", borderRadius: "5px"}} >Active for Lifetime</button>
                    </>:
                         <button onClick={()=> onMembershipAction("DEACTIVE")} style={{background: "red", marginLeft: "10px", border: "none", color: "white", padding: "5px 5px", borderRadius: "5px"}} >Deactive</button>
                    }
               </td>
               <td>{date}</td>
          </tr>
     );
};

const ErrorMessage = (props) => {
     return (
          <div className='d-flex align-items-center justify-content-center' style={{height: "300px", fontSize: '16px'}}>
               {props.message}
          </div>
     );
}

export default Devices;